module.exports = __webpack_public_path__ + "nm-icons_ed0f962e28326130e817dc0e4d267a8b.ttf?f697b89e7860ed8071951f966de2d31a";


//////////////////
// WEBPACK FOOTER
// ./provolution/app/views/provolution/common_assets/fonts/iconfont/nm-icons_ed0f962e28326130e817dc0e4d267a8b.ttf
// module id = 1342
// module chunks = 15